import { render } from "./product-gallery-carousel.vue?vue&type=template&id=5ac4611a"
import script from "./product-gallery-carousel.vue?vue&type=script&lang=js"
export * from "./product-gallery-carousel.vue?vue&type=script&lang=js"

import "./product-gallery-carousel.vue?vue&type=style&index=0&id=5ac4611a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__